/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentResult } from '../../models/agent-result';

export interface GetnotificationsAgentUpdatedSchema$Params {
}

export function getnotificationsAgentUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsAgentUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResult>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsAgentUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentResult>;
    })
  );
}

getnotificationsAgentUpdatedSchema.PATH = '/api/hubs/notifications/AgentUpdated';
